import React, { useCallback, useRef, useState, useMemo } from "react";
import { connect } from "react-redux";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import {
    Column,
    DataGrid,
    Scrolling,
    FilterRow,
    Export,
    ColumnChooser,
    Selection,
    Toolbar,
    Item,
    StateStoring,
    ColumnChooserSearch
} from "devextreme-react/data-grid";

import GridLayoutManager from "../../../../../../gridLayoutCustomization/GridLayoutManager";
import { GridLayout } from "../../../../../../common/GridLayout";

function Invoices(props) {
    const chargeDataGrid = useRef(null);
    const invoiceDataGrid = useRef(null);
    let accessToken = props.oidc.user.access_token;
    
    const invoiceGridKey = "4cdda414-2bc1-4d51-8c25-22e5c977ad83";
    const [invoiceGridCurrentLayout, setInvoiceGridCurrentLayout] = useState("Default");
    const saveInvoiceGridState = useCallback((state) => { GridLayout.sendStorageRequest(invoiceGridKey, "POST", accessToken, state, invoiceGridCurrentLayout); }, [invoiceGridKey, invoiceGridCurrentLayout]);
    const loadInvoiceGridState = useCallback(() => { return GridLayout.sendStorageRequest(invoiceGridKey, "GET", accessToken,null, invoiceGridCurrentLayout); }, [invoiceGridCurrentLayout]);

    const chargeGridKey = "523c2ff2-13fc-45c6-8a4b-31358a01f5fa";
    const [chargeGridCurrentLayout, setChargeGridCurrentLayout] = useState("Default");
    const saveChargeGridState = useCallback((state) => { GridLayout.sendStorageRequest(chargeGridKey, "POST", accessToken, state, chargeGridCurrentLayout); }, [chargeGridKey, chargeGridCurrentLayout]);
    const loadChargeGridState = useCallback(() => { return GridLayout.sendStorageRequest(chargeGridKey, "GET", accessToken,null, chargeGridCurrentLayout); }, [chargeGridCurrentLayout]);
    
    const [invoiceGridSelectedItemKeys, setInvoiceGridSelectedItemKeys] = useState([]);
    const invoiceGridDataSource = createStore({
        key: 'rowid',
        loadParams:
        {
            WMTransactionHeaderRowId: function () {
                return props.WMTransactionHeaderRowId;
            }                
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/UpdateInvoice/SearchInvoices`,
        onBeforeSend: (method, ajaxOptions) => {
            ajaxOptions.headers = {
                access_token: accessToken,
                Authorization: `Bearer ${accessToken}`,
            };
        },
    });
    const [chargeGridSelectedItemKeys, setChargeGridSelectedItemKeys] = useState([]);

    const handleInvoiceSelectionChange = (data) => {
        setInvoiceGridSelectedItemKeys(data.selectedRowKeys);
        chargeDataGrid.current.instance().option("dataSource", createStore({
                key: 'rowid',
                loadUrl: `${window._env_.REACT_APP_APIS}/wm/UpdateInvoice/GetInvoiceDetails`,
                onBeforeSend: function (method, ajaxOptions) {
                        ajaxOptions.headers = {
                            Authorization: `Bearer ${accessToken}`,
                            Key: data.selectedRowKeys && data.selectedRowKeys.length > 0 ? data.selectedRowKeys[0] : "00000000-0000-0000-0000-000000000000"
                        };
                    }
                }));
    }

    const handleChargeSelectionChange = (data) => {
        setChargeGridSelectedItemKeys(data.selectedRowKeys);
    }

    const onContentReady = (e) => {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            e.component.option("dataSource", invoiceGridDataSource);
             
        }
        else if (!e.component._firstRowSelected)
        {
            e.component._firstRowSelected = true;
            var selection = e.component.getSelectedRowKeys();  
            if(selection.length == 0) {  
                e.component.selectRowsByIndexes([0]);  
            } 
        }
    };

    return (
        <div>
            <DataGrid
                ref={invoiceDataGrid}
                onExporting={(e) => {
                    if (window.handleDevExtremeDataGridExport) {
                        window.handleDevExtremeDataGridExport(e);
                    }
                }}
                selectedRowKeys={invoiceGridSelectedItemKeys}
                showBorders={true}
                rowAlternationEnabled={true}
                allowColumnReordering={true}
                allowColumnResizing={true}
                columnAutoWidth={true}
                onSelectionChanged={handleInvoiceSelectionChange}
                height="30vh"
                key={"rowid"}
                onContentReady={onContentReady}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Scrolling mode="standard" />
                <Selection mode="single" />
                <Export enabled={true} allowExportSelectedData={true} />
                <FilterRow visible={true} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadInvoiceGridState}
                    storageKey={invoiceGridKey}
                    customSave={saveInvoiceGridState}
                />  
                <Column dataField="invoiceNumber" caption="Invoice Number" dataType="string" sortOrder="asc" sortIndex={0}/>
                <Column dataField="invoiceDate" caption="Invoice Date" dataType="date" format="MM/dd/yyyy" />
                <Column dataField="dueDate" caption="Due Date" dataType="date" format="MM/dd/yyyy" />
                <Column dataField="commitDate" caption="Commit Date" dataType="date" format="MM/dd/yyyy" />
                <Column dataField="referenceNumber" caption="Reference #" dataType="string" />
                <Column dataField="amount" caption="Invoice Amount" dataType="number" format="$#,###0.00"/>
                <Toolbar>
                    <Item location="after">
                        <GridLayoutManager gridKey={invoiceGridKey} dataGrid={invoiceDataGrid} setCurrentLayout={setInvoiceGridCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
            <div style={{marginTop:"10px"}}></div>
            <DataGrid
                ref={chargeDataGrid}
                onExporting={(e) => {
                    if (window.handleDevExtremeDataGridExport) {
                        window.handleDevExtremeDataGridExport(e);
                    }
                }}
                selectedRowKeys={chargeGridSelectedItemKeys}
                showBorders={true}
                rowAlternationEnabled={true}
                allowColumnReordering={true}
                allowColumnResizing={true}
                columnAutoWidth={true}
                onSelectionChanged={handleChargeSelectionChange}
                height="30vh"
                key={"rowid"}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Scrolling mode="standard" />
                <Selection mode="single" />
                <Export enabled={true} allowExportSelectedData={true} />
                <FilterRow visible={true} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadChargeGridState}
                    storageKey={chargeGridKey}
                    customSave={saveChargeGridState}
                />  
                <Column dataField="chargeCode" caption='Charge' dataType="string">
                </Column>
                <Column dataField="description" caption="Description" dataType="string" />
                <Column dataField="chargeType" caption="Charge Type" dataType="string" />
                <Column dataField="quantityBillAs" caption="Bill As" dataType="number"
                    format="#,###0.00"
                />
                <Column dataField="amount" caption="Amount"  dataType="number"
                    format="$#,###0.00"
                />
                <Toolbar>
                    <Item location="after">
                        <GridLayoutManager gridKey={chargeGridKey} dataGrid={chargeDataGrid} setCurrentLayout={setChargeGridCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(Invoices);
